<template>
    <div :ref="setRef" class="border-box-contaier" :style="{position: 'absolute', width: '520px', height: '320px'}">

      <div class="tw-border-box-1" v-if="borderName === '边框1'">
        <svg class="tw-border-svg-container" :width="width" :height="actualHeight">
          <path fill="transparent" stroke="#6586ec" :d="`M 5 20 L 5 10 L 12 3  L 60 3 L 68 10 L ${actualWidth - 20} 10 L ${actualWidth - 5} 25 L ${actualWidth - 5} ${actualHeight - 5} L 20 ${actualHeight - 5} L 5 ${actualHeight - 20} L 5 20`" />

          <path fill="transparent" stroke-width="3" stroke-linecap="round" stroke-dasharray="10, 5" stroke="#6586ec" :d="`M 16 9 L 61 9`" />

          <path fill="transparent" stroke="#2cf7fe" :d="`M 5 20 L 5 10 L 12 3  L 60 3 L 68 10`" />

          <path fill="transparent" stroke="#2cf7fe" :d="`M ${actualWidth - 5} ${actualHeight - 30} L ${actualWidth - 5} ${actualHeight - 5} L ${actualWidth - 30} ${actualHeight - 5}`" />
        </svg>
        <div class="border-box-content">
          <slot></slot>
        </div>
      </div>

      <div class="tw-border-box-2" v-else-if="borderName === '边框2'">
        <div class="tw-border-box-2" style="background-color: transparent; box-shadow: rgba(128, 128, 128, 0.3) 0px 0px 40px inset; border: 1px solid rgba(128, 128, 128, 0.3);">
          <svg class="tw-svg-container" :width="actualWidth" :height="actualHeight">
            <polyline class="tw-bb2-line-width-2" stroke="rgba(128,128,128,0.3)" :points="`0, 25 0, 0 25, 0`" />
            <polyline class="tw-bb2-line-width-2" stroke="rgba(128,128,128,0.3)" :points="`${actualWidth - 25}, 0 ${actualWidth}, 0 ${actualWidth}, 25`" />
            <polyline class="tw-bb2-line-width-2" stroke="rgba(128,128,128,0.3)" :points="`${actualWidth - 25}, ${actualHeight} ${actualWidth}, ${actualHeight} ${actualWidth}, ${actualHeight - 25}`" />
            <polyline class="tw-bb2-line-width-2" stroke="rgba(128,128,128,0.3)" :points="`0, ${actualHeight - 25} 0, ${actualHeight} 25, ${actualHeight}`" />

            <polyline class="tw-bb2-line-width-5" stroke="rgba(128,128,128,0.5)" :points="`0, 10 0, 0 10, 0`" />
            <polyline class="tw-bb2-line-width-5" stroke="rgba(128,128,128,0.5)" :points="`${actualWidth - 10}, 0 ${actualWidth}, 0 ${actualWidth}, 10`" />
            <polyline class="tw-bb2-line-width-5" stroke="rgba(128,128,128,0.5)" :points="`${actualWidth - 10}, ${actualHeight} ${actualWidth}, ${actualHeight} ${actualWidth}, ${actualHeight - 10}`" />
            <polyline class="tw-bb2-line-width-5" stroke="rgba(128,128,128,0.5)" :points="`0, ${actualHeight - 10} 0, ${actualHeight} 10, ${actualHeight}`" />
          </svg>
          <div class="border-box-content">
            <slot></slot>
          </div>
        </div>
      </div>

      <div class="tw-border-box-3" v-else-if="borderName === '边框3'">
        <svg class="tw-svg-container" :width="actualWidth" :height="actualHeight">
      <defs>
        <path :id="path" :d="`M2.5, 2.5 L${actualWidth - 2.5}, 2.5 L${actualWidth - 2.5}, ${actualHeight - 2.5} L2.5, ${actualHeight - 2.5} L2.5, 2.5`" fill="transparent" />
        <radialGradient :id="gradient" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#fff" stop-opacity="1" />
          <stop offset="100%" stop-color="#fff" stop-opacity="0" />
        </radialGradient>

        <mask :id="mask">
          <circle cx="0" cy="0" r="150" :fill="`url(#${gradient})`">
            <animateMotion dur="3s" :path="`M2.5, 2.5 L${actualWidth - 2.5}, 2.5 L${actualWidth - 2.5}, ${actualHeight - 2.5} L2.5, ${actualHeight - 2.5} L2.5, 2.5`" rotate="auto" repeatCount="indefinite" />
          </circle>
        </mask>
      </defs>

      <use stroke="#235fa7" stroke-width="1" :xlink:href="`#${path}`" />

      <use stroke="#4fd2dd" stroke-width="3" :xlink:href="`#${path}`" :mask="`url(#${mask})`">
        <animate attributeName="stroke-dasharray" :from="`0, ${length}`" :to="`${length}, 0`" dur="3s" repeatCount="indefinite" />
      </use>
    </svg>
        <div class="border-box-content">
          <slot></slot>
        </div>
      </div>

      <div class="tw-border-box-4" v-else-if="borderName === '边框4'">
        <svg class="tw-svg-container" :width="actualWidth" :height="actualHeight">
          <defs>
            <linearGradient :id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <animate attributeName="x1" values="0%;100%;0%" dur="10s" begin="0s" repeatCount="indefinite" />

              <animate attributeName="x2" values="100%;0%;100%" dur="10s" begin="0s" repeatCount="indefinite" />

              <stop offset="0%" stop-color="#11eefd">
                <animate attributeName="stop-color" values="#11eefd;#0078d2;#11eefd" dur="10s" begin="0s" repeatCount="indefinite" />
              </stop>
              <stop offset="100%" stop-color="#0078d2">
                <animate attributeName="stop-color" values="#0078d2;#11eefd;#0078d2" dur="10s" begin="0s" repeatCount="indefinite" />
              </stop>
            </linearGradient>

            <mask :id="mask">
              <polyline stroke="#fff" stroke-width="3" :points="`8, ${actualHeight * 0.4} 8, 3, ${actualWidth * 0.4 + 7}, 3`" />
              <polyline fill="#fff" :points=" `8, ${actualHeight * 0.15} 8, 3, ${actualWidth * 0.1 + 7}, 3 ${actualWidth * 0.1}, 8 14, 8 14, ${actualHeight * 0.15 - 7}`" />

              <polyline stroke="#fff" stroke-width="3" fill="transparent" :points="`${actualWidth * 0.5}, 3 ${actualWidth - 3}, 3, ${actualWidth - 3}, ${actualHeight * 0.25}`" />
              <polyline fill="#fff" :points="` ${actualWidth * 0.52}, 3 ${actualWidth * 0.58}, 3 ${actualWidth * 0.58 - 7}, 9 ${actualWidth * 0.52 + 7}, 9`" />
              <polyline fill="#fff" :points="` ${actualWidth * 0.9}, 3 ${actualWidth - 3}, 3 ${actualWidth - 3}, ${actualHeight * 0.1} ${actualWidth - 9}, ${actualHeight * 0.1 - 7} ${actualWidth - 9}, 9 ${actualWidth * 0.9 + 7}, 9`" />

              <polyline stroke="#fff" stroke-width="3" fill="transparent" :points="`8, ${actualHeight * 0.5} 8, ${actualHeight - 3} ${actualWidth * 0.3 + 7}, ${actualHeight - 3}`" />
              <polyline fill="#fff" :points="`8, ${actualHeight * 0.55} 8, ${actualHeight * 0.7} 2, ${actualHeight * 0.7 - 7} 2, ${actualHeight * 0.55 + 7} `" />

              <polyline stroke="#fff" stroke-width="3" fill="transparent" :points="`${actualWidth * 0.35}, ${actualHeight - 3} ${actualWidth - 3}, ${actualHeight - 3} ${actualWidth - 3}, ${actualHeight * 0.35}`" />
              <polyline fill="#fff" :points="`${actualWidth * 0.92}, ${actualHeight - 3} ${actualWidth - 3}, ${actualHeight - 3} ${actualWidth - 3}, ${actualHeight * 0.8} ${actualWidth - 9}, ${actualHeight * 0.8 + 7} ${actualWidth - 9}, ${actualHeight - 9} ${actualWidth * 0.92 + 7}, ${actualHeight - 9}`" />
            </mask>
          </defs>

          <rect x="0" y="0" :width="actualWidth" :height="actualHeight" :fill="`url(#${gradient})`" :mask="`url(#${mask})`" />
        </svg>
        <div class="border-box-content">
          <slot></slot>
        </div>
      </div>

      <div class="tw-border-box-5" v-else-if="borderName === '边框5'" style="box-shadow: inset 0 0 25px 3px rgb(29, 72, 196);">
        <svg width="150px" height="150px" :key="item" v-for="item in ['left-top', 'right-top', 'left-bottom', 'right-bottom']" :class="`${item} border tw-border-svg-container`">
          <polygon fill="#d3e1f8" points="40, 0 5, 0 0, 5 0, 16 3, 19 3, 7 7, 3 35, 3"/>
        </svg>
        <div class="border-box-content">
          <slot></slot>
        </div>
      </div>

      <div class="tw-border-box-6" v-else-if="borderName === '边框6'">
        <svg width="504" height="240" class="border"><polygon fill="transparent" points="10, 27 10, 213 13, 216 13, 219 24, 229 38, 229 41, 232 73, 232 75, 230 81, 230 85, 234 419, 234 423, 230 429, 230 431, 232 463, 232 466, 229 480, 229 491, 219 491, 216 494, 213 494, 27 491, 25 491, 21 480, 11 466, 11 463, 8 431, 8 429, 10 423, 10 419, 6 85, 6 81, 10 75, 10 73, 8 41, 8 38, 11 24, 11 13, 21 13, 24"></polygon></svg> 
        <svg width="150px" height="150px" class="left-top border"><polygon points="6,66 6,18 12,12 18,12 24,6 27,6 30,9 36,9 39,6 84,6 81,9 75,9 73.2,7 40.8,7 37.8,10.2 24,10.2 12,21 12,24 9,27 9,51 7.8,54 7.8,63" fill="#4fd2dd"><animate attributeName="fill" values="#4fd2dd;#235fa7;#4fd2dd" dur="0.5s" begin="0s" repeatCount="indefinite"></animate></polygon> <polygon points="27.599999999999998,4.8 38.4,4.8 35.4,7.8 30.599999999999998,7.8" fill="#235fa7"><animate attributeName="fill" values="#235fa7;#4fd2dd;#235fa7" dur="0.5s" begin="0s" repeatCount="indefinite"></animate></polygon> <polygon points="9,54 9,63 7.199999999999999,66 7.199999999999999,75 7.8,78 7.8,110 8.4,110 8.4,66 9.6,66 9.6,54" fill="#4fd2dd"><animate attributeName="fill" values="#4fd2dd;#235fa7;transparent" dur="1s" begin="0s" repeatCount="indefinite"></animate></polygon></svg>
        <svg width="150px" height="150px" class="right-top border"><polygon points="6,66 6,18 12,12 18,12 24,6 27,6 30,9 36,9 39,6 84,6 81,9 75,9 73.2,7 40.8,7 37.8,10.2 24,10.2 12,21 12,24 9,27 9,51 7.8,54 7.8,63" fill="#4fd2dd"><animate attributeName="fill" values="#4fd2dd;#235fa7;#4fd2dd" dur="0.5s" begin="0s" repeatCount="indefinite"></animate></polygon> <polygon points="27.599999999999998,4.8 38.4,4.8 35.4,7.8 30.599999999999998,7.8" fill="#235fa7"><animate attributeName="fill" values="#235fa7;#4fd2dd;#235fa7" dur="0.5s" begin="0s" repeatCount="indefinite"></animate></polygon> <polygon points="9,54 9,63 7.199999999999999,66 7.199999999999999,75 7.8,78 7.8,110 8.4,110 8.4,66 9.6,66 9.6,54" fill="#4fd2dd"><animate attributeName="fill" values="#4fd2dd;#235fa7;transparent" dur="1s" begin="0s" repeatCount="indefinite"></animate></polygon></svg>
        <svg width="150px" height="150px" class="left-bottom border"><polygon points="6,66 6,18 12,12 18,12 24,6 27,6 30,9 36,9 39,6 84,6 81,9 75,9 73.2,7 40.8,7 37.8,10.2 24,10.2 12,21 12,24 9,27 9,51 7.8,54 7.8,63" fill="#4fd2dd"><animate attributeName="fill" values="#4fd2dd;#235fa7;#4fd2dd" dur="0.5s" begin="0s" repeatCount="indefinite"></animate></polygon> <polygon points="27.599999999999998,4.8 38.4,4.8 35.4,7.8 30.599999999999998,7.8" fill="#235fa7"><animate attributeName="fill" values="#235fa7;#4fd2dd;#235fa7" dur="0.5s" begin="0s" repeatCount="indefinite"></animate></polygon> <polygon points="9,54 9,63 7.199999999999999,66 7.199999999999999,75 7.8,78 7.8,110 8.4,110 8.4,66 9.6,66 9.6,54" fill="#4fd2dd"><animate attributeName="fill" values="#4fd2dd;#235fa7;transparent" dur="1s" begin="0s" repeatCount="indefinite"></animate></polygon></svg>
        <svg width="150px" height="150px" class="right-bottom border"><polygon points="6,66 6,18 12,12 18,12 24,6 27,6 30,9 36,9 39,6 84,6 81,9 75,9 73.2,7 40.8,7 37.8,10.2 24,10.2 12,21 12,24 9,27 9,51 7.8,54 7.8,63" fill="#4fd2dd"><animate attributeName="fill" values="#4fd2dd;#235fa7;#4fd2dd" dur="0.5s" begin="0s" repeatCount="indefinite"></animate></polygon> <polygon points="27.599999999999998,4.8 38.4,4.8 35.4,7.8 30.599999999999998,7.8" fill="#235fa7"><animate attributeName="fill" values="#235fa7;#4fd2dd;#235fa7" dur="0.5s" begin="0s" repeatCount="indefinite"></animate></polygon> <polygon points="9,54 9,63 7.199999999999999,66 7.199999999999999,75 7.8,78 7.8,110 8.4,110 8.4,66 9.6,66 9.6,54" fill="#4fd2dd"><animate attributeName="fill" values="#4fd2dd;#235fa7;transparent" dur="1s" begin="0s" repeatCount="indefinite"></animate></polygon></svg> 
        <div class="border-box-content">
          <slot></slot>
        </div>
      </div>

    </div>
</template>

<script>
import { ref, nextTick, computed } from 'vue'
export default {
    name: "tw-ws-border",

    setup(){
        let myRef;
        var actualWidth = ref(0);
        var actualHeight = ref(0);
        const timestamp = Date.now()
        const path = ref(`border-box-path-${timestamp}`);
        const gradient = ref(`border-box-gradient-${timestamp}`);
        const mask = ref(`border-box-mask-${timestamp}`);

        const length = computed(() => {
            return (actualWidth.value + actualHeight.value - 5) * 2
        })

        const setRef = el => {
            myRef = el;
        }

        nextTick(() => {
            if(myRef){
                actualHeight.value = myRef.offsetHeight;
                actualWidth.value = myRef.offsetWidth;
            }
        })

        return{
          actualHeight,
          actualWidth,
          setRef,
          path,
          gradient,
          mask,
          length
        }
    },

    props:{
      borderName: {
        type: String,
        default: '边框1'
      }
    }
}
</script>

<style scoped lang="scss">

</style>